import { PayloadAction } from '@reduxjs/toolkit';

import { UndoRedoState } from 'editor/src/store/editorModules/undoRedo/types';

const setSaveStepsReducer = (state: UndoRedoState, action: PayloadAction<boolean>) => {
  state.saveSteps = action.payload;
};

export default setSaveStepsReducer;
